import { $Q, $Qll } from '../utils/querySelector';
import '../scss/ourDistributors.scss';

/**
 * Organize our distributors country list alphabetically
 * @author Lina Arroyo <lina.arroyo@gradiweb.com>
 */

const countryList = $Q('#countryList');

if (countryList) {
  //Take country list from BO and organize it and push it to a new object
  let countryListObj = [];

  for (const child of countryList.children) {
    countryListObj.push(child);
  }

  // Sort this object by the nodes' innerHTML and include accented vowels in said sort

  countryListObj.sort((nameA, nameB) =>
    nameA.innerHTML.localeCompare(nameB.innerHTML, 'fi', {
      caseFirst: 'upper',
    })
  );

  // Push nodes to new div in order and add classes that differentiate them

  const newContainer = $Q('#display-countries-here');

  countryListObj.forEach(function (item) {
    let itemString = item.innerHTML;
    let firstLetter = itemString
      .charAt(0)
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toUpperCase();
    if (!item.hasAttribute('href')) {
      return
      // item.classList.add('countryListItem', 'countryInitial');
      // item.setAttribute('initial', firstLetter);
    } else {
      item.classList.add('countryListItem', 'countryName');
      item.setAttribute('initial', firstLetter);
    }
    newContainer.appendChild(item);
  });

  // Group items by initial letter

  let groups = {};
  const countryListItems = $Qll('.countryListItem');

  countryListItems.forEach((item) => {
    const attr = item.getAttribute('initial');
    let group = groups[attr];

    if (!group) {
      group = document.createElement('div');
      group.className = 'letterGroup';
      group.dataset.letter = attr
      item.parentNode.insertBefore(group, item.nextSibling);
      groups[attr] = group;
    }
    group.appendChild(item);
  });

  // Hide initial letter if two initials are next to each other (meaning there are not countries with that initial)

  const initials = $Qll('.countryInitial');

  for (let initial of initials) {
    const parent = initial.closest('.letterGroup');
    if (
      initial.nextSibling == undefined ||
      initial.nextSibling.classList.contains('countryInitial')
    ) {
      parent.classList.add('hidden-initial');
    }
  }
}
